<template>
	<div class="list-group-item">

		<template v-if="data">
			<p class="mb-1 mt-1">
				<strong v-if="$config.getValue('feedback').showteachername">{{data.userabout_displayname}}</strong>
				<template v-if="data.datetime">
					{{ $datetime.getLocaleStringFromTimeStamp(data.datetime, false) }}
				</template>
			</p>
			<p style="white-space: pre-wrap;">{{data.content}}</p>
			<template v-if="data.formresponse_data">
				<FormGrid :page="data.formresponse_data.pages[0]" readonly="1" viewAs="submitter"></FormGrid>
			</template>
             <div v-if="data.tags.length > 0">
                <span v-for="(tag, index) in data.tags" :key="index" class="badge badge-primary mr-2">{{tag.tag_name}}</span>
            </div>

		</template>

		<template v-else>

			{{$t('loading')}}

		</template>

	</div>
</template>

<script>
import FormGrid from "src/components/FormEditor/FormGrid";
export default {
	components: {
		FormGrid
	},
	props: ['data', 'swipedLeftItem'],
	data() {
		return {
		};
	},
	mounted() {
	},
	created: function () {
	},
	destroyed: function () {
	},
	methods: {
	},
	computed: {
	}
};
</script>
